var map = {
	"./project-1-1@2x.png": 183,
	"./project-1-2@2x.png": 936,
	"./project-1-3@2x.png": 93,
	"./project-1-4@2x.png": 777,
	"./project-2-1@2x.png": 321,
	"./project-2-2@2x.png": 678,
	"./project-2-3@2x.png": 375,
	"./project-3@2x.png": 180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;